import { useFragment, graphql } from 'react-relay';
import {
    type useDisplayInfo_displayInfo$data,
    type useDisplayInfo_displayInfo$key,
} from './__generated__/useDisplayInfo_displayInfo.graphql.ts';
import { type useDisplayInfo_multiskus$key } from './__generated__/useDisplayInfo_multiskus.graphql.ts';

const displayInfoFragment = graphql`
    fragment useDisplayInfo_displayInfo on ItemDisplayInfo {
        ctas {
            showPurchase
            showMakeOffer
            showRequestPrice
            showAcceptOffer
        }
    }
`;

const multiskusFragment = graphql`
    fragment useDisplayInfo_multiskus on ItemSkuType @relay(plural: true) {
        serviceId
        displayInfo(page: pdp, buyerId: $userId) {
            ctas {
                showPurchase
                showMakeOffer
                showRequestPrice
                showAcceptOffer
            }
        }
    }
`;

type UseDisplayInfoData = Pick<useDisplayInfo_displayInfo$data, 'ctas'>;
type Props = {
    displayInfo?: useDisplayInfo_displayInfo$key | null;
    skus?: useDisplayInfo_multiskus$key | null;
    selectedSkuId?: string | null;
};

export const useDisplayInfo = ({
    displayInfo: displayInfoRef,
    skus: skusRef,
    selectedSkuId,
}: Props): UseDisplayInfoData | null | undefined => {
    const defaultDisplayInfo = useFragment(displayInfoFragment, displayInfoRef);
    const multiSkus = useFragment(multiskusFragment, skusRef);

    if (multiSkus && selectedSkuId) {
        const selectedSku = multiSkus.find(sku => sku?.serviceId === selectedSkuId);
        if (selectedSku?.displayInfo) {
            return selectedSku.displayInfo;
        }
    }

    return defaultDisplayInfo;
};
